import React, { useState, useEffect } from 'react'

interface IProgressIndicator {
    progress?: number
    max?: number
    done?: boolean
    className?: string
    size?: 'small' | 'medium' | 'large'
    isSuccess?: boolean
}

const ProgressIndicator = ({ progress = 0, max = 100, done = false, className, size = 'medium' }: IProgressIndicator) => {
    const [displayProgress, setDisplayProgress] = useState(progress)
    
    // Плавная анимация
    useEffect(() => {
        if (done) {
            setDisplayProgress(max)
            return
        }
        
        const targetProgress = Math.min(progress, max)
        const step = (targetProgress - displayProgress) / 15
        
        if (Math.abs(targetProgress - displayProgress) > 0.5) {
            const timer = setTimeout(() => {
                setDisplayProgress(prev => prev + step)
            }, 16)
            return () => clearTimeout(timer)
        } else {
            setDisplayProgress(targetProgress)
        }
    }, [progress, max, displayProgress, done])
    
    const percentage = max > 0 ? (displayProgress / max) * 100 : 0
    
    const sizes = {
        small: { container: 16, inner: 10 },
        medium: { container: 20, inner: 12 },
        large: { container: 24, inner: 16 }
    }
    
    const currentSize = sizes[size]
    
    if (done) {
        return (
            <div 
                className={className}
                style={{
                    width: currentSize.container,
                    height: currentSize.container,
                    borderRadius: '50%',
                    backgroundColor: '#11BB2B'
                }}
            />
        )
    }
    
    // Круговой прогресс
    return (
        <div 
            className={className}
            style={{
                position: 'relative',
                width: currentSize.container,
                height: currentSize.container,
                borderRadius: '50%',
                backgroundColor: '#e5e7eb'
            }}
        >
            <div 
                style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    background: `conic-gradient(#10b981 0deg ${percentage * 3.6}deg, #e5e7eb ${percentage * 3.6}deg 360deg)`,
                    transition: 'all 0.3s ease-out'
                }}
            >
                <div 
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: currentSize.inner,
                        height: currentSize.inner,
                        borderRadius: '50%',
                        backgroundColor: '#ffffff'
                    }}
                />
            </div>
        </div>
    )
}

ProgressIndicator.defaultProps = {
    progress: 0,
    max: 100,
    done: false,
    size: 'medium'
}

export default ProgressIndicator